var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"login"}},[_c('kdw-auth-component',{attrs:{"sign-up-type":_vm.signUpType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }